import { useGetExocetPdsToQualify } from '../../../../../../hooks/datarefs';
import { useInterventionCreation } from '../../context/interventionCreationContext';
import { NO_FILTERS, TableFilters, toQueryParams } from '../../../../../Tools/Table/filters';
import { RequestRow } from './requestRows';

/**
 * La v1 utilisait `lastPdsImport` comme jeton de cache-busting dans la clé de requête ;
 * la v2 rafraîchit par `invalidateQueries`, d'où une valeur stable.
 */
const NO_CACHE_BUSTER = 0;

export type RequestsToQualifyState = {
  rows: RequestRow[];
  count: number;
  isFetching: boolean;
  /**
   * Vrai tant qu'aucun compte n'est encore connu, et seulement là.
   *
   * `count` vaut 0 avant la première réponse : qui l'affiche doit pouvoir distinguer ce
   * zéro d'un vrai zéro. Ni `isFetching`, qui vaut aussi vrai pendant un rafraîchissement
   * où le compte précédent est servi et reste juste, ni `isLoading`, qui reste vrai en
   * permanence tant que la requête est désactivée faute de client.
   */
  isInitialLoading: boolean;
};

/**
 * Demandes de l'étape Qualification. Encapsulé pour que le panneau et le compteur du
 * stepper partagent exactement la même clé de requête — donc le même cache.
 */
export function useRequestsToQualify(filters: TableFilters = NO_FILTERS): RequestsToQualifyState {
  const { state } = useInterventionCreation();

  const { data, isFetching, isInitialLoading } = useGetExocetPdsToQualify(
    state.clientId === null ? '' : String(state.clientId),
    NO_CACHE_BUSTER,
    toQueryParams(filters)
  );

  return {
    rows: data?.results ?? [],
    count: data?.count ?? 0,
    isFetching,
    isInitialLoading
  };
}
